const b = {
  transparent: "#00000000",
  aliceblue: "#f0f8ff",
  antiquewhite: "#faebd7",
  aqua: "#00ffff",
  aquamarine: "#7fffd4",
  azure: "#f0ffff",
  beige: "#f5f5dc",
  bisque: "#ffe4c4",
  black: "#000000",
  blanchedalmond: "#ffebcd",
  blue: "#0000ff",
  blueviolet: "#8a2be2",
  brown: "#a52a2a",
  burlywood: "#deb887",
  cadetblue: "#5f9ea0",
  chartreuse: "#7fff00",
  chocolate: "#d2691e",
  coral: "#ff7f50",
  cornflowerblue: "#6495ed",
  cornsilk: "#fff8dc",
  crimson: "#dc143c",
  cyan: "#00ffff",
  darkblue: "#00008b",
  darkcyan: "#008b8b",
  darkgoldenrod: "#b8860b",
  darkgray: "#a9a9a9",
  darkgreen: "#006400",
  darkgrey: "#a9a9a9",
  darkkhaki: "#bdb76b",
  darkmagenta: "#8b008b",
  darkolivegreen: "#556b2f",
  darkorange: "#ff8c00",
  darkorchid: "#9932cc",
  darkred: "#8b0000",
  darksalmon: "#e9967a",
  darkseagreen: "#8fbc8f",
  darkslateblue: "#483d8b",
  darkslategray: "#2f4f4f",
  darkslategrey: "#2f4f4f",
  darkturquoise: "#00ced1",
  darkviolet: "#9400d3",
  deeppink: "#ff1493",
  deepskyblue: "#00bfff",
  dimgray: "#696969",
  dimgrey: "#696969",
  dodgerblue: "#1e90ff",
  firebrick: "#b22222",
  floralwhite: "#fffaf0",
  forestgreen: "#228b22",
  fuchsia: "#ff00ff",
  gainsboro: "#dcdcdc",
  ghostwhite: "#f8f8ff",
  gold: "#ffd700",
  goldenrod: "#daa520",
  gray: "#808080",
  green: "#008000",
  greenyellow: "#adff2f",
  grey: "#808080",
  honeydew: "#f0fff0",
  hotpink: "#ff69b4",
  indianred: "#cd5c5c",
  indigo: "#4b0082",
  ivory: "#fffff0",
  khaki: "#f0e68c",
  lavender: "#e6e6fa",
  lavenderblush: "#fff0f5",
  lawngreen: "#7cfc00",
  lemonchiffon: "#fffacd",
  lightblue: "#add8e6",
  lightcoral: "#f08080",
  lightcyan: "#e0ffff",
  lightgoldenrodyellow: "#fafad2",
  lightgray: "#d3d3d3",
  lightgreen: "#90ee90",
  lightgrey: "#d3d3d3",
  lightpink: "#ffb6c1",
  lightsalmon: "#ffa07a",
  lightseagreen: "#20b2aa",
  lightskyblue: "#87cefa",
  lightslategray: "#778899",
  lightslategrey: "#778899",
  lightsteelblue: "#b0c4de",
  lightyellow: "#ffffe0",
  lime: "#00ff00",
  limegreen: "#32cd32",
  linen: "#faf0e6",
  magenta: "#ff00ff",
  maroon: "#800000",
  mediumaquamarine: "#66cdaa",
  mediumblue: "#0000cd",
  mediumorchid: "#ba55d3",
  mediumpurple: "#9370db",
  mediumseagreen: "#3cb371",
  mediumslateblue: "#7b68ee",
  mediumspringgreen: "#00fa9a",
  mediumturquoise: "#48d1cc",
  mediumvioletred: "#c71585",
  midnightblue: "#191970",
  mintcream: "#f5fffa",
  mistyrose: "#ffe4e1",
  moccasin: "#ffe4b5",
  navajowhite: "#ffdead",
  navy: "#000080",
  oldlace: "#fdf5e6",
  olive: "#808000",
  olivedrab: "#6b8e23",
  orange: "#ffa500",
  orangered: "#ff4500",
  orchid: "#da70d6",
  palegoldenrod: "#eee8aa",
  palegreen: "#98fb98",
  paleturquoise: "#afeeee",
  palevioletred: "#db7093",
  papayawhip: "#ffefd5",
  peachpuff: "#ffdab9",
  peru: "#cd853f",
  pink: "#ffc0cb",
  plum: "#dda0dd",
  powderblue: "#b0e0e6",
  purple: "#800080",
  rebeccapurple: "#663399",
  red: "#ff0000",
  rosybrown: "#bc8f8f",
  royalblue: "#4169e1",
  saddlebrown: "#8b4513",
  salmon: "#fa8072",
  sandybrown: "#f4a460",
  seagreen: "#2e8b57",
  seashell: "#fff5ee",
  sienna: "#a0522d",
  silver: "#c0c0c0",
  skyblue: "#87ceeb",
  slateblue: "#6a5acd",
  slategray: "#708090",
  slategrey: "#708090",
  snow: "#fffafa",
  springgreen: "#00ff7f",
  steelblue: "#4682b4",
  tan: "#d2b48c",
  teal: "#008080",
  thistle: "#d8bfd8",
  tomato: "#ff6347",
  turquoise: "#40e0d0",
  violet: "#ee82ee",
  wheat: "#f5deb3",
  white: "#ffffff",
  whitesmoke: "#f5f5f5",
  yellow: "#ffff00",
  yellowgreen: "#9acd32"
};
function w(r) {
  const e = r.trim().toLowerCase();
  if (e.startsWith("#"))
    return u(e);
  if (e.startsWith("rgb"))
    return y(e);
  if (e.startsWith("hsl"))
    return k(e);
  if (b[e])
    return I(e);
  throw new Error(`Unsupported color format: ${r}`);
}
function u(r) {
  const e = r.slice(1);
  if (e.length < 3) throw new Error(`Invalid hex color format: ${r}`);
  let a, f, n, i = 1;
  if (e.length <= 4) {
    if (typeof e[0] != "string") throw new Error(`Invalid hex color format: ${r}`);
    if (typeof e[1] != "string") throw new Error(`Invalid hex color format: ${r}`);
    if (typeof e[2] != "string") throw new Error(`Invalid hex color format: ${r}`);
    if (a = parseInt(e[0] + e[0], 16), f = parseInt(e[1] + e[1], 16), n = parseInt(e[2] + e[2], 16), e.length === 4) {
      if (typeof e[3] != "string") throw new Error(`Invalid hex color format: ${r}`);
      i = parseInt(e[3] + e[3], 16) / 255;
    }
  } else if (e.length === 6)
    a = parseInt(e.slice(0, 2), 16), f = parseInt(e.slice(2, 4), 16), n = parseInt(e.slice(4, 6), 16);
  else if (e.length === 8)
    a = parseInt(e.slice(0, 2), 16), f = parseInt(e.slice(2, 4), 16), n = parseInt(e.slice(4, 6), 16), i = parseInt(e.slice(6, 8), 16) / 255;
  else
    throw new Error(`Invalid hex color format: ${r}`);
  return { r: a, g: f, b: n, a: i };
}
function y(r) {
  const e = r.match(/rgba?\(([^)]+)\)/);
  if (!e)
    throw new Error(`Invalid RGB color format: ${r}`);
  if (typeof e[1] != "string") throw new Error("Invalid RGB color format: " + r);
  const a = e[1].trim().split(/[ ,/]+/).map((s) => s.trim());
  if (a.length < 3 || a.length > 4)
    throw new Error(`Invalid RGB color format: ${r}`);
  if (typeof a[0] != "string" || typeof a[1] != "string" || typeof a[2] != "string")
    throw new Error(`Invalid RGB color format: ${r}`);
  const f = h(a[0], 255), n = h(a[1], 255), i = h(a[2], 255);
  let t = 1;
  return a.length === 4 && typeof a[3] == "string" && (t = m(a[3], 1)), { r: f, g: n, b: i, a: t };
}
function k(r) {
  const e = r.match(/hsla?\(([^)]+)\)/);
  if (!e)
    throw new Error(`Invalid HSL color format: ${r}`);
  if (typeof e[1] != "string") throw new Error("Invalid RGB color format: " + r);
  const a = e[1].trim().split(/[ ,/]+/).map((o) => o.trim());
  if (a.length < 3 || a.length > 4)
    throw new Error(`Invalid HSL color format: ${r}`);
  if (typeof a[0] != "string" || typeof a[1] != "string" || typeof a[2] != "string")
    throw new Error(`Invalid HSL color format: ${r}`);
  const f = parseFloat(a[0]) / 360, n = parseFloat(a[1].replace("%", "")) / 100, i = parseFloat(a[2].replace("%", "")) / 100;
  let t = 1;
  a.length === 4 && typeof a[3] == "string" && (t = m(a[3], 1));
  const { r: s, g: c, b: d } = v(f, n, i);
  return { r: s, g: c, b: d, a: t };
}
function h(r, e) {
  return r.includes("%") ? Math.round(parseFloat(r.replace("%", "")) / 100 * e) : Math.min(e, Math.max(0, Math.round(parseFloat(r))));
}
function m(r, e) {
  return r.includes("%") ? parseFloat(r.replace("%", "")) / 100 * e : Math.min(e, Math.max(0, parseFloat(r)));
}
function v(r, e, a) {
  let f, n, i;
  if (e === 0)
    f = n = i = a;
  else {
    const t = (d, o, l) => (l < 0 && (l += 1), l > 1 && (l -= 1), l < 0.16666666666666666 ? d + (o - d) * 6 * l : l < 0.5 ? o : l < 0.6666666666666666 ? d + (o - d) * (0.6666666666666666 - l) * 6 : d), s = a < 0.5 ? a * (1 + e) : a + e - a * e, c = 2 * a - s;
    f = t(c, s, r + 1 / 3), n = t(c, s, r), i = t(c, s, r - 1 / 3);
  }
  return {
    r: Math.round(f * 255),
    g: Math.round(n * 255),
    b: Math.round(i * 255)
  };
}
function I(r) {
  return b[r] ? u(b[r]) : null;
}
const $ = (r, e) => {
  const a = r.map((t) => typeof t == "string" ? w(t) : t);
  if (a.length === 0)
    throw new Error("Colors array cannot be empty");
  if (e <= 0)
    throw new Error("Output size must be greater than 0");
  if (e === 1) {
    if (a[0])
      return [{ r: a[0].r, g: a[0].g, b: a[0].b, a: a[0].a }];
    throw new Error("Colors array cannot be empty");
  }
  if (a.length === 1) {
    const t = a[0];
    if (typeof t < "u")
      return Array(e).fill(null).map(() => ({ r: t.r, g: t.g, b: t.b, a: t.a }));
    throw new Error("Colors array cannot be empty");
  }
  const f = [], n = a.length - 1, i = (e - 1) / n;
  for (let t = 0; t < e; t++) {
    const s = Math.min(
      Math.floor(t / i),
      n - 1
    ), c = t / i - s, d = Math.min(c, 1), o = a[s], l = a[s + 1];
    if (o && l) {
      const p = {
        r: Math.round(o.r + (l.r - o.r) * d),
        g: Math.round(o.g + (l.g - o.g) * d),
        b: Math.round(o.b + (l.b - o.b) * d),
        a: o.a + (l.a - o.a) * d
      };
      f.push(p);
    }
  }
  return f;
};
function E(r) {
  return `rgba(${r.r}, ${r.g}, ${r.b}, ${r.a})`;
}
const g = (r) => {
  const e = Math.round(Math.max(0, Math.min(255, r))).toString(16);
  return e.length === 1 ? "0" + e : e;
};
function C(r) {
  const e = g(r.r), a = g(r.g), f = g(r.b);
  if (r.a === 1)
    return `#${e}${a}${f}`;
  const n = g(r.a * 255);
  return `#${e}${a}${f}${n}`;
}
export {
  $ as fadeColors,
  C as getCssHexColor,
  E as getCssRgbaColor
};
//# sourceMappingURL=color-fader.js.map
